"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const handlebars_1 = tslib_1.__importDefault(require("handlebars"));
const defaults_1 = tslib_1.__importDefault(require("lodash/defaults"));
const truncate_1 = tslib_1.__importDefault(require("lodash/truncate"));
const isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
const defaultCompileOptions = {
    knownHelpers: {},
    knownHelpersOnly: true,
    noEscape: true,
    strict: true,
    assumeObjects: true,
};
function assertHandlebars(hb) {
    if (!hb) {
        throw Error('Tried to compile templates before installing the formatter.');
    }
}
class HandlebarsTemplateFormatter {
    constructor(options = {}) {
        this.name = 'HandlebarsTemplateFormatter';
        this.cache = null;
        this.compileOptions = {};
        this.handlebars = null;
        this.installing = null;
        const { cache = null, compileOptions = {} } = options;
        this.cache = cache;
        this.compileOptions = defaults_1.default({}, compileOptions, defaultCompileOptions);
    }
    install() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.installing = new Promise((res) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a;
                yield ((_a = this.cache) === null || _a === void 0 ? void 0 : _a.install());
                this.handlebars = handlebars_1.default.create();
                res();
            }));
            return this.installing;
        });
    }
    close() {
        var _a, _b, _c;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.installing)
                yield this.installing;
            (_b = (_a = this.handlebars) === null || _a === void 0 ? void 0 : _a.noConflict) === null || _b === void 0 ? void 0 : _b.call(_a);
            yield ((_c = this.cache) === null || _c === void 0 ? void 0 : _c.close());
            this.installing = null;
        });
    }
    format(template, context, options = {}) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.installing)
                yield this.installing;
            const { textLimit } = options;
            assertHandlebars(this.handlebars);
            const handlebarsTemplate = (yield ((_a = this.cache) === null || _a === void 0 ? void 0 : _a.get(template))) ||
                this.handlebars.compile(template, this.compileOptions);
            if (this.cache && !(yield this.cache.has(template))) {
                yield this.cache.set(template, handlebarsTemplate);
            }
            const text = handlebarsTemplate(context);
            return !isNil_1.default(textLimit) ? truncate_1.default(text, { length: textLimit }) : text;
        });
    }
}
exports.default = HandlebarsTemplateFormatter;
//# sourceMappingURL=HandlebarsTemplateFormatter.js.map